import React from 'react';
import ReactDOM from 'react-dom/client';
import './/style/index.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import { GlobalStateProvider } from './utils/GlobalStateContext';
import { installAuthFetch } from './utils/apiClient';

// Patch global fetch to attach Firebase ID tokens to API requests. Must run
// before any component issues a fetch.
installAuthFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStateProvider>
      <App />
    </GlobalStateProvider>
  </React.StrictMode>
);

reportWebVitals();